import React from 'react';
/**
 * Config for WetLab Display.
 * @return {WetLabLogic}
 */
function WetLabLogic() {
  return (<p>WetLab</p>

  );
}

export default WetLabLogic;
